import { Descriptions, Divider, Tag } from 'antd'
import classNames from 'classnames'
import dayjs from 'dayjs'

import type { CardfileData } from '@/api/cardfile/cardfileApi'

import cn from './CardfileDetails.module.scss'

type CardfileDetailsProps = {
  data: CardfileData
  isOrganisationSelected?: boolean
}

function CardfileDetails({
  data,
  isOrganisationSelected = false,
}: CardfileDetailsProps) {
  const stats = [
    { label: 'Приказные (Взыскатель)', value: data.writ?.debtor },
    { label: 'Приказные (Должник)', value: data.writ?.creditor },
    { label: 'Исполнительные производства', value: data.executory?.debtor },
  ]
  const imnsDebtsCount = data.imns_debtors?.length ?? 0
  const checksCount = data.checks?.length ?? 0

  return (
    <div className={cn.details}>
      <Descriptions bordered column={1} size="small">
        <Descriptions.Item label="Наименование">
          <b>{data.name || data.egr_name}</b>
        </Descriptions.Item>
        <Descriptions.Item label="Статус ЕГР">
          <Tag color={data.egr_status_code === 1 ? 'green' : 'volcano'}>
            {data.egr_status_name || 'Не указан'}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Юридический адрес">
          {data.address}
        </Descriptions.Item>
        <Descriptions.Item label="Дата регистрации">
          {data.egr_reg_date
            ? dayjs(data.egr_reg_date).format('DD.MM.YYYY')
            : '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Вид деятельности (ОКЭД)">
          {data.oked_primary_name} <Tag>{data.oked_primary_code}</Tag>
        </Descriptions.Item>
      </Descriptions>

      <Divider orientation="left">Суды и задолженности</Divider>
      <div className={cn.statsGrid}>
        {stats.map((stat) => (
          <div key={stat.label} className={cn.statBox}>
            <span className={cn.statLabel}>{stat.label}</span>
            <span
              className={classNames(
                cn.statValue,
                isOrganisationSelected && cn.statValueSelected
              )}
            >
              {stat.value ?? 0}
            </span>
          </div>
        ))}
      </div>

      <Divider orientation="left">Налоги и Проверки</Divider>
      <Descriptions bordered column={2} size="small">
        <Descriptions.Item label="Долги перед бюджетом">
          {imnsDebtsCount > 0 ? (
            <Tag color="error">Есть задолженность ({imnsDebtsCount})</Tag>
          ) : (
            <Tag color="success">Задолженностей нет</Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Статус МНС">
          {data.status_mns}
        </Descriptions.Item>
        <Descriptions.Item label="Плановые проверки">
          {checksCount > 0
            ? `Запланировано: ${checksCount}`
            : 'Проверок не запланировано'}
        </Descriptions.Item>
      </Descriptions>

      <Divider orientation="left">Дополнительно</Divider>
      <Descriptions bordered column={2} size="small">
        <Descriptions.Item label="Торговые марки">
          {data.trademarks?.quantity ?? 0}
        </Descriptions.Item>
        <Descriptions.Item label="Сертификаты соответствия">
          {data.certs_of_conf?.quantity ?? 0}
        </Descriptions.Item>
      </Descriptions>
    </div>
  )
}

export default CardfileDetails
